<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => ({}),
    },
    size: {
      type: String,
      required: false,
      default: '',
    },
    call: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      home: this.items[0],
      actions: this.items.filter((action) => action.name !== 'Home'),
    }
  },
  computed: {
    btnSize() {
      if (this.size !== '') {
        return `btn-group-${this.size}`
      } else {
        return ''
      }
    },
  },
  watch: {
    items(value) {
      this.actions = value.filter((action) => action.name !== 'Home')
    },
  },
  methods: {
    actionClick(action) {
      this.call(action)
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="home.name === 'Home'"
      class="btn-group mb-2 mr-2"
      :class="btnSize"
    >
      <button
        :id="home.name"
        :key="home.name"
        :targetElement="home.targetElement"
        type="button"
        class="btn btn-light"
        @click="actionClick(home.name)"
      >
        <b-tooltip :target="home.name" triggers="hover">{{
          home.name
        }}</b-tooltip>
        <i :class="home.cssclass"></i>
      </button>
    </div>
    <transition-group
      name="slide"
      tag="div"
      class="btn-group mb-2"
      :class="btnSize"
    >
      <button
        v-for="item in actions"
        :id="item.name"
        :key="item.name"
        :targetElement="item.targetElement"
        type="button"
        class="btn btn-light"
        @click="actionClick(item.name)"
      >
        <b-tooltip :target="item.name" triggers="hover">{{
          item.name
        }}</b-tooltip>
        <i :class="item.cssclass"></i>
        {{ item.name }}
      </button>
    </transition-group>
  </div>
</template>
